export default __webpack_public_path__ + "static/media/Version (3) - Order of the Phoenix_04.c8de3064.jpg";